import { render, staticRenderFns } from "./identify_off.vue?vue&type=template&id=8927bfc0&scoped=true&"
import script from "./identify_off.vue?vue&type=script&lang=js&"
export * from "./identify_off.vue?vue&type=script&lang=js&"
import style0 from "./identify_off.vue?vue&type=style&index=0&id=8927bfc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8927bfc0",
  null
  
)

export default component.exports